import type FinancingTermsOverview from '../../../contracts/FinancingTermsOverview';
import { AsyncState } from '../../../store/types';

export type TermsOverviewState = AsyncState & {
  overview: FinancingTermsOverview | null;
};

export type FinancingTermsSliceState = {
  entities: Record<string, unknown> | null;
  financingTerms: AsyncState;
  termsOverview: TermsOverviewState;
};

const FETCH_FINANCING_TERMS_BEGIN = 'account/FinancingTerms/FETCH_FINANCING_TERMS_BEGIN';
const FETCH_FINANCING_TERMS_SUCCESS = 'account/FinancingTerms/FETCH_FINANCING_TERMS_SUCCESS';
const FETCH_FINANCING_TERMS_FAILURE = 'account/FinancingTerms/FETCH_FINANCING_TERMS_FAILURE';
const FETCH_TERMS_OVERVIEW_BEGIN = 'account/FinancingTerms/FETCH_TERMS_OVERVIEW_BEGIN';
const FETCH_TERMS_OVERVIEW_SUCCESS = 'account/FinancingTerms/FETCH_TERMS_OVERVIEW_SUCCESS';
const FETCH_TERMS_OVERVIEW_FAILURE = 'account/FinancingTerms/FETCH_TERMS_OVERVIEW_FAILURE';
const TOGGLE_COAPPLICANT_STATUS_SUCCESS =
  'account/FinancingTerms/TOGGLE_COAPPLICANT_STATUS_SUCCESS';

export {
  FETCH_FINANCING_TERMS_BEGIN,
  FETCH_FINANCING_TERMS_SUCCESS,
  FETCH_FINANCING_TERMS_FAILURE,
  FETCH_TERMS_OVERVIEW_BEGIN,
  FETCH_TERMS_OVERVIEW_SUCCESS,
  FETCH_TERMS_OVERVIEW_FAILURE,
  TOGGLE_COAPPLICANT_STATUS_SUCCESS
};
